<div class="main-container">

  <div class="page-header">
    <div class="title">
      <span class="title-text">Manage Users</span>
      <p class="small-title">Every user, their roles and permissions (central or per establishment), and access status.</p>
    </div>

    <div class="header-actions">
      <input
        type="search"
        class="text-box-active search-box"
        placeholder="Search name, username, mobile or role"
        aria-label="Search users"
        [formControl]="search"
      />
      <button type="button" class="ac-primary-btn" [disabled]="isLoading" (click)="addUser()">Add User</button>
    </div>
  </div>

  <div class="table-container ac-table-region" role="region" aria-label="Users" tabindex="0">
    <table class="table ac-responsive-table">
      <thead class="table-head">
        <tr>
          <th scope="col">Name</th>
          <th scope="col">Username</th>
          <th scope="col">Mobile</th>
          <th scope="col">Role(s)</th>
          <th scope="col">Access</th>
          <th scope="col">Actions</th>
        </tr>
      </thead>
      <tbody class="table-body">
        @for(user of filteredUsers(); track user.sumId){
        <tr>
          <td data-label="Name">{{ user.fullName }}</td>
          <td data-label="Username">{{ user.userName }}</td>
          <td data-label="Mobile">{{ user.mobileNumber || '-' }}</td>
          <td data-label="Role(s)">{{ user.roles || '-' }}</td>
          <td data-label="Access">{{ user.isRestricted ? 'Restricted' : 'Active' }}</td>
          <td class="ac-actions-column actions-cell" data-label="Actions">
            <button type="button" class="ac-secondary-small-btn" [disabled]="isLoading" (click)="manage(user)">Manage</button>
            @if(!user.isSelf){
            <button type="button" class="ac-secondary-small-btn" [disabled]="isLoading" (click)="toggleRestricted(user)">
              {{ user.isRestricted ? 'Unrestrict' : 'Restrict' }}
            </button>
            }
          </td>
        </tr>
        }
        @if(!isLoading && filteredUsers().length === 0){
        <tr>
          <td colspan="6" class="empty-row">{{ search.value ? 'No users match the search.' : 'No users found.' }}</td>
        </tr>
        }
      </tbody>
    </table>
  </div>

</div>

<app-loader [isLoading]="isLoading"></app-loader>
